'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _setImmediate2 = require('babel-runtime/core-js/set-immediate');

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountBar = function (_React$Component) {
  (0, _inherits3.default)(AccountBar, _React$Component);

  function AccountBar() {
    (0, _classCallCheck3.default)(this, AccountBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AccountBar.__proto__ || (0, _getPrototypeOf2.default)(AccountBar)).call(this));

    _this.handleWindowClick = _this.handleWindowClick.bind(_this);
    _this.handleToggleClick = _this.handleToggleClick.bind(_this);

    _this.state = {
      open: false
    };
    return _this;
  }

  (0, _createClass3.default)(AccountBar, [{
    key: 'handleToggleClick',
    value: function handleToggleClick(ev) {
      var _this2 = this;

      this.setState({ open: !this.state.open });

      (0, _setImmediate3.default)(function () {
        if (!_this2.state.open) {
          window.removeEventListener('click', _this2.handleWindowClick);
        } else {
          window.addEventListener('click', _this2.handleWindowClick);
        }
      });
    }
  }, {
    key: 'handleWindowClick',
    value: function handleWindowClick() {
      this.setState({ open: false });
      window.removeEventListener('click', this.handleWindowClick);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener("click", this.handleWindowClick);
    }
  }, {
    key: 'stopEventPropagation',
    value: function stopEventPropagation(ev) {
      if (ev.target.nodeName.toLowerCase() != 'a' && ev.target.nodeName.toLowerCase() != 'button') {
        ev.stopPropagation();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var open = this.state.open;

      var styles = require('./AccountBar.scss');

      var accountBarMiniProfileClasses = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles['AccountBar__mini-profile'], true), (0, _defineProperty3.default)(_classnames, styles['AccountBar__mini-profile--open'], open), _classnames));

      return _react2.default.createElement(
        'div',
        { className: styles.AccountBar },
        _react2.default.createElement(
          'div',
          { className: styles.AccountBar__profile },
          _react2.default.createElement('i', { className: styles['AccountBar__user-icon'] + " fa fa-user", onClick: this.handleToggleClick }),
          _react2.default.createElement(
            'div',
            { className: accountBarMiniProfileClasses, onClick: this.stopEventPropagation },
            _react2.default.createElement('span', { className: styles['AccountBar__mini-profile-angle'] }),
            _react2.default.createElement(_components.MiniProfileBar, null)
          )
        )
      );
    }
  }]);
  return AccountBar;
}(_react2.default.Component);

exports.default = AccountBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountBar/AccountBar.jsx
// module id = 2493
// module chunks = 0